import React from 'react';
import { FiEye } from 'react-icons/fi';

export const VaultCardListCompact = ({ vault, badge, onClick }) => {
  const balance =
    typeof vault.balance === 'number'
      ? vault.balance.toLocaleString(undefined, { maximumFractionDigits: 2 })
      : vault.balance ?? '0';

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick?.()}
      className="flex items-center justify-between px-4 py-2 hover:bg-white/5 transition cursor-pointer group"
    >
      <div className="flex items-center gap-3 min-w-0">
        {/* status dot mirrors badge color vibe */}
        <span className="w-2.5 h-2.5 rounded-full bg-current opacity-80"
          style={{ color: 'currentcolor' }} />
        <div className="text-sm text-white/90 font-medium truncate max-w-[180px]">
          {vault.vaultAlias}
        </div>
        {/* inline badge */}
        <div className="shrink-0">{badge}</div>
      </div>

      <div className="text-xs text-white/70 tabular-nums">
        {vault.currencyCode} {balance}
      </div>

      <div className="text-[11px] text-white/50 uppercase hidden md:block">
        {vault.country}
      </div>

      {/* quick peek on hover */}
      <button
        className="opacity-0 group-hover:opacity-100 transition-opacity inline-flex items-center gap-1
                   text-xs px-2 py-1 rounded-md bg-black/30 hover:bg-black/50"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
        aria-label={`Quick peek ${vault.vaultAlias ?? vault.id}`}
      >
        <FiEye /> Peek
      </button>
    </div>
  );
};
